import React from "react";
import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  ISkuFormatSaveRequest,
  SkuFormatSaveRequest,
  SaveResponse,
} from "services/KnowfullyAdminClient";

import SkuFormatForm from "./SkuFormatForm";

type SkuFormatCreateFormProps = {
  onSkuFormatCreated: (id: string) => void;
  onCancel: () => void;
};

const SkuFormatCreateForm = ({
  onSkuFormatCreated,
  onCancel,
}: SkuFormatCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const onSubmit = (values: ISkuFormatSaveRequest) => {
    return registerPromise(
      skuService.saveSkuFormat(new SkuFormatSaveRequest(values))
    )
      .then(({ id }: SaveResponse) => {
        onSkuFormatCreated(id!);
      })
      .catch((err: any) => {
        console.log(err);
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <SkuFormatForm
      onSubmit={onSubmit}
      submitLabel={t({ id: "skuFormatCreateButton" })}
      onCancel={onCancel}
    />
  );
};

export default SkuFormatCreateForm;
